import React from 'react';

import { Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import type { ActivityFilter } from './email-thread';
import { ACTIVITY_FILTER_LABELS, ACTIVITY_FILTERS } from './email-thread';

const useStyles = makeStyles()(theme => ({
  chip: {
    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.appColors.primary}`,
      outlineOffset: 1,
    },
    '&:hover': {
      backgroundColor: theme.appColors.hoverBackgroundSubtle,
    },
    backgroundColor: theme.palette.common.white,
    borderColor: theme.appColors.ruleSubtle,
    color: theme.appColors.iconsType,
    fontSize: 12,
    height: 28,
  },
  label: {
    padding: theme.spacing(0, 1),
  },
  root: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: 6,
  },
  selected: {
    '&:hover': {
      backgroundColor: theme.appColors.selectedBackgroundNav,
    },
    backgroundColor: theme.appColors.hoverBackgroundSubtle,
    borderColor: theme.appColors.primary,
    color: theme.appColors.primary,
    fontWeight: 600,
  },
}));

interface ActivityFilterChipsProps {
  filter: ActivityFilter;
  onChange: (filter: ActivityFilter) => void;
}

/** Narrows the activity list to one kind of entry. */
export const ActivityFilterChips = React.memo(function ActivityFilterChips({
  filter,
  onChange,
}: ActivityFilterChipsProps) {
  const { classes, cx } = useStyles();

  return (
    <div aria-label="Filter activity" className={classes.root} role="group">
      {ACTIVITY_FILTERS.map(option => (
        <Chip
          key={option}
          aria-pressed={option === filter}
          className={cx(classes.chip, option === filter && classes.selected)}
          classes={{ label: classes.label }}
          label={ACTIVITY_FILTER_LABELS[option]}
          variant="outlined"
          onClick={() => onChange(option)}
        />
      ))}
    </div>
  );
});
